export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const USER_LOADING = 'USER_LOADING';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const USER_VERIFIED = 'USER_VERIFIED';
export const VERIFICATION_FAILED = 'VERIFICATION_FAILED';
